export class ServiceProductLineMapper {
    private static readonly serviceToProductLines: Record<string, string[]> = {
        SAS: ['WASHROOM', 'INDUSTRIAL_WIPERS'],
        FON: ['BEVERAGES'],
        CAF: ['BEVERAGES'],
        VT: ['GARMENTS'],
        LS: ['MOPS_AND_CLOTHS', 'FLAT_LINEN'],
        SOL: ['MATS'],
        '3D': ['PEST_CONTROL'],
        DASRI: ['INFECTIOUS_WASTE'],
    };

    public static getProductLines(serviceCode: string): string[] {
        return this.serviceToProductLines[serviceCode] || [];
    }

    public static isMatch(serviceCode: string, productLineCode: string): boolean {
        return this.getProductLines(serviceCode).includes(productLineCode);
    }

    public static productLineCodeToServiceCode(productLineCode: string) {
        switch (productLineCode) {
            case 'WASHROOM':
            case 'INDUSTRIAL_WIPERS':
                return 'SAS';

            case 'BEVERAGES':
                return 'FON/CAF';

            case 'GARMENTS':
                return 'VT';

            case 'MOPS_AND_CLOTHS':
            case 'FLAT_LINEN':
                return 'LS';

            case 'MATS':
                return 'SOL';

            case 'PEST_CONTROL':
                return '3D';

            case 'INFECTIOUS_WASTE':
                return 'DASRI';
        }
    }


    public static mapProductLinesToServiceCodes(productLineCodes: string[][]): string[] {
        const serviceCodes = new Set<string>();

        productLineCodes.forEach(productLineCode => {
            const serviceCode = this.productLineCodeToServiceCode(productLineCode[0]);
            if (serviceCode) {
                serviceCodes.add(serviceCode);
            }
        });

        return Array.from(serviceCodes);
    }

}
